import { HeaderNavbarMobileWrapperDefaultBox } from "./header-navbar-mobile-wrapper.default.box";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import { HeaderNavbarMobileWrapperSiBox } from "./header-navbar-mobile-wrapper.si.box";

export const HeaderNavbarMobileWrapperBox = styledByTheme(HeaderNavbarMobileWrapperDefaultBox)
    .forSI(HeaderNavbarMobileWrapperSiBox)
    .forSICis(HeaderNavbarMobileWrapperSiBox)
    .apply();
